(function (window, document) {
  const Utils = window.MVTUtils;

  const Application = window.MVTApplicationModule;

  function getApplicationModule() {
    return window.MVTApplicationModule || Application;
  }

  if (typeof window._MVT_FETCH_FLOW_RUNNING === "undefined") {
    window._MVT_FETCH_FLOW_RUNNING = false;
  }

  function saveMVTContextToSession(context) {
    try {
      if (context && typeof sessionStorage !== "undefined") {
        sessionStorage.setItem("mvt_context", JSON.stringify(context));
      }
    } catch (e) {}
  }

  function restoreMVTContextFromSession() {
    try {
      if (typeof sessionStorage !== "undefined") {
        const stored = sessionStorage.getItem("mvt_context");
        if (stored) {
          return JSON.parse(stored);
        }
      }
    } catch (e) {}
    return null;
  }

  function fireMetricConversionShared(
    metric,
    publicApiBase,
    projectId,
    campaignId,
    visitorId,
    pageUrl,
  ) {
    if (!window.MVTTrack || !metric) return;
    const dedupKey = `_mvt_fired_${metric.id}`;
    if (window[dedupKey]) return;
    window[dedupKey] = true;

    window.MVTTrack.trackConversion({
      publicApiBase: publicApiBase,
      projectId: projectId,
      campaignId: campaignId,
      visitorId: visitorId,
      metricId: metric.id,
      eventApiName: metric.eventApiName,
      pageUrl: pageUrl,
    })
      .then((result) => {
        if (result) {
          console.log("MVT Engine: Conversion tracked", {
            metricId: metric.id,
            eventApiName: metric.eventApiName,
            isUnique: result.isUnique,
          });
        }
      })
      .catch((err) => {
        console.warn("MVT Engine: Conversion tracking failed", { metricId: metric.id, err });
      });
  }

  function resetMetricDedupForNavigation(metrics, currentUrl) {
    if (!metrics || !metrics.length) return;
    if (window.__mvt_dedup_url === currentUrl) return;
    window.__mvt_dedup_url = currentUrl;

    window.__mvt_manual_metrics = {};
    metrics.forEach((metric) => {
      if (!metric) return;
      delete window[`_mvt_fired_${metric.id}`];
      delete window[`_mvt_bound_${metric.id}`];
    });
  }

  function registerManualMetric(metric, publicApiBase, projectId, campaignId, visitorId) {
    if (!metric || !metric.eventApiName) return;
    const key = String(metric.eventApiName).toLowerCase();
    window.__mvt_manual_metrics = window.__mvt_manual_metrics || {};
    window.__mvt_manual_metrics[key] = {
      metric: metric,
      publicApiBase: publicApiBase,
      projectId: projectId,
      campaignId: campaignId,
      visitorId: visitorId,
    };
    console.log("MVT Engine: Custom event armed, awaiting manual conversion call", {
      metricId: metric.id,
      eventApiName: metric.eventApiName,
      hint: "call mvt('conversion', { eventApiName: '" + metric.eventApiName + "' })",
    });
  }

  function resolveManualMetric(eventApiName) {
    if (!eventApiName || !window.__mvt_manual_metrics) return null;
    return window.__mvt_manual_metrics[String(eventApiName).toLowerCase()] || null;
  }

  function fireManualMetric(eventApiName, pageUrl) {
    const entry = resolveManualMetric(eventApiName);
    if (!entry) return false;
    fireMetricConversionShared(
      entry.metric,
      entry.publicApiBase,
      entry.projectId,
      entry.campaignId,
      entry.visitorId,
      pageUrl || window.location.href,
    );
    return true;
  }

  window.MVTResolveManualMetric = resolveManualMetric;
  window.MVTFireManualMetric = fireManualMetric;

  function bindFirstEventListener(eventName, metric, fireFn, useCapture) {
    if (!metric) return;
    const boundKey = `_mvt_bound_${metric.id}`;
    if (window[boundKey]) return;
    window[boundKey] = true;
    const handler = function () {
      fireFn();
      document.removeEventListener(eventName, handler, useCapture);
    };
    document.addEventListener(eventName, handler, useCapture);
  }

  const FETCH = {
    fetchConfigAndRun: async function (
      projectKey,
      assignedGroup,
      configApiEndpoint,
      flickerClass,
      changesApiBase,
      publicApiBase,
    ) {
      const resolvedChangesBase =
        changesApiBase ||
        (configApiEndpoint ? configApiEndpoint.replace(/\/projects\/config$/, "/projects") : "");
      const assignedGroupParam = assignedGroup || "default-group";

      const resolvedPublicApiBase =
        publicApiBase ||
        (configApiEndpoint ? configApiEndpoint.replace(/\/projects\/config$/, "/public") : "");

      let isVerifyMode = false;
      try {
        const pageUrl = new URL(window.location.href);
        const verifyParam = pageUrl.searchParams.get("verify");
        if (typeof verifyParam === "string") {
          const lower = verifyParam.toLowerCase();
          isVerifyMode = verifyParam === projectKey || lower === "true" || verifyParam === "1";
        }
        console.log("MVT Engine: Verify param detection", {
          found: verifyParam != null,
          value: verifyParam,
          isVerifyMode: isVerifyMode,
          projectKey: projectKey,
        });
      } catch (e) {}

      window.MVTVerifyMode = isVerifyMode;

      const tuning = (window.MVTConfigModule && window.MVTConfigModule.getConfig()) || {};
      const REVEAL_FAST_MS = Number.isFinite(tuning.revealFastMs) ? tuning.revealFastMs : 1200;
      const REVEAL_MAX_MS = Number.isFinite(tuning.revealMaxMs) ? tuning.revealMaxMs : 2000;

      const TARGET_REVEAL_MAX_MS = Math.max(
        REVEAL_MAX_MS,
        Number.isFinite(tuning.targetRevealMaxMs) ? tuning.targetRevealMaxMs : 4000,
      );
      const CACHE_ENABLED = tuning.cacheEnabled !== false;

      const SCOPED_HIDE_ENABLED = tuning.scopedHide !== false;

      const SERVE_ENABLED = tuning.serveEnabled === true;

      let bodyRevealed = false;
      let targetsRevealed = false;
      const revealBody = () => {
        if (bodyRevealed) return;
        bodyRevealed = true;
        try {
          Utils.removeFlickerClass(flickerClass);
        } catch (e) {}
      };
      const revealTargets = () => {
        if (targetsRevealed) return;
        targetsRevealed = true;
        try {
          Utils.removeScopedHide();
        } catch (e) {}
      };

      const reveal = () => {
        revealBody();
        revealTargets();
      };

      const isRevealed = () => bodyRevealed;

      const BODY_HOLD_MAX_MS = Math.max(
        REVEAL_MAX_MS,
        Number.isFinite(tuning.bodyHoldMaxMs) ? tuning.bodyHoldMaxMs : 3000,
      );
      let hardCapTimer = setTimeout(() => {
        if (document.getElementById("mvt-scoped-hide") || BODY_HOLD_MAX_MS === REVEAL_MAX_MS) {
          revealBody();
          return;
        }
        hardCapTimer = setTimeout(revealBody, BODY_HOLD_MAX_MS - REVEAL_MAX_MS);
      }, REVEAL_MAX_MS);
      const targetCapTimer = setTimeout(revealTargets, TARGET_REVEAL_MAX_MS);

      try {
        window.__MVT_APPLY_DEADLINE__ = Date.now() + TARGET_REVEAL_MAX_MS;
      } catch (e) {}

      const runVerifyFlow = async () => {
        const currentPageUrl = window.location.href;
        const apiUrl = `${configApiEndpoint}?projectKey=${projectKey}${
          isVerifyMode ? `&verify=${encodeURIComponent(projectKey)}` : ""
        }&url=${encodeURIComponent(currentPageUrl)}`;

        const requestOptions = {
          method: "GET",

          headers: {
            "Cache-Control": "no-cache",
            "X-MVT-Page-URL": currentPageUrl,
          },
        };

        console.log("MVT Engine: Verify request", {
          url: apiUrl,
          options: requestOptions,
          verifyMode: isVerifyMode,
          projectKey: projectKey,
          assignedGroup: assignedGroup,
        });

        const response = await fetch(apiUrl, requestOptions);

        console.log("MVT Engine: Verify response meta", {
          status: response.status,
          ok: response.ok,
          redirected: response.redirected,
          type: response.type,
          url: response.url,
        });

        if (!response.ok) {
          let errorBody = null;
          try {
            errorBody = await response.text();
          } catch (e) {}
          console.error("MVT Engine: Fetch response body (error)", errorBody);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const config = await response.json();
        console.log("MVT Engine: Verify response JSON (success)", config);
        return config && config.responseHeader && config.responseHeader.status === 200;
      };

      const runChangesFlow = async () => {
        if (window._MVT_FETCH_FLOW_RUNNING) {
          console.warn("MVT Engine: Fetch flow already running, skipping duplicate execution");
          return;
        }
        window._MVT_FETCH_FLOW_RUNNING = true;

        let visitorId = Utils.getOrCreateVisitorId(projectKey);
        const currentPageUrl = window.location.href;

        injectVisitorIdIntoForms(visitorId);

        const assignmentBeacons = {};
        const assignmentSessionKey = (campaignId) =>
          `mvt_tracked_${projectKey}_${campaignId}_${visitorId}`;

        const assignmentRecordedInSession = (campaignId, variantKey) => {
          try {
            return sessionStorage.getItem(assignmentSessionKey(campaignId)) === variantKey;
          } catch (e) {
            return false;
          }
        };
        const markAssignmentRecorded = (campaignId, variantKey) => {
          try {
            sessionStorage.setItem(assignmentSessionKey(campaignId), variantKey);
          } catch (e) {}
        };

        const recordAssignment = (params) => {
          const campaignId = params && params.campaignId;
          const variantKey = params && params.variantKey;
          if (!campaignId || !variantKey || !window.MVTTrack) {
            return Promise.resolve(null);
          }

          const beaconKey = `${campaignId}|${variantKey}`;
          if (assignmentBeacons[beaconKey]) return assignmentBeacons[beaconKey];

          const trackVisitor = () =>
            window.MVTTrack.trackVisitor({
              publicApiBase: resolvedPublicApiBase,
              projectId: projectKey,
              campaignId: campaignId,
              variantKey: variantKey,
              visitorId: visitorId,
            });

          let beacon;
          if (Utils && Utils.consentBlocked && Utils.consentBlocked()) {
            beacon = trackVisitor();
          } else if (assignmentRecordedInSession(campaignId, variantKey)) {
            console.log(
              "MVT Engine: Visitor already tracked in this session, skipping duplicate tracking",
              {
                campaignId,
                variantKey,
              },
            );
            beacon = Promise.resolve({ isNewVisitor: false, variantKey: variantKey });
          } else {
            beacon = window.MVTTrack.getAssignment({
              publicApiBase: resolvedPublicApiBase,
              projectId: projectKey,
              campaignId: campaignId,
              visitorId: visitorId,
            })
              .then((assignment) => {
                void assignment;
                return trackVisitor();
              })
              .then((result) => {
                if (result) markAssignmentRecorded(campaignId, variantKey);
                return result;
              });
          }

          beacon = beacon.catch((err) => {
            console.warn("MVT Engine: Visitor tracking failed", err);
            return null;
          });

          assignmentBeacons[beaconKey] = beacon;
          return beacon;
        };

        let holdBodyForVariant = true;
        let scopedHideActive = false;
        if (SCOPED_HIDE_ENABLED) {
          try {
            const cachedManifest = Utils.getCachedManifest(projectKey);
            if (cachedManifest && cachedManifest.selectors && cachedManifest.selectors.length) {
              scopedHideActive = Utils.injectScopedHide(cachedManifest.selectors);
              if (scopedHideActive && !holdBodyForVariant) {
                revealBody();
              }
            }
          } catch (e) {}
          if (resolvedChangesBase) {
            Utils.fetchSelectorManifest(projectKey, resolvedChangesBase)
              .then((manifest) => {
                if (!manifest || !manifest.selectors) return;
                Utils.setCachedManifest(projectKey, manifest);

                if (!targetsRevealed && manifest.selectors.length) {
                  try {
                    const armed = Utils.injectScopedHide(manifest.selectors);
                    if (armed) {
                      scopedHideActive = true;

                      if (!holdBodyForVariant) revealBody();
                    }
                  } catch (e) {}
                }
              })
              .catch(() => {});
          }
        }

        let preparedVariant = null;

        let recordPreparedAssignment = null;
        if (CACHE_ENABLED) {
          const cached = Utils.getCachedVariant(projectKey, currentPageUrl);
          if (cached && cached.variant) {
            preparedVariant = cached.variant;
            const cachedTrigger = cached.activationTrigger || null;

            const preparedCampaignId = cached.campaignId || preparedVariant.campaignId;
            const preparedVariantKey = cached.variantKey || preparedVariant.key;
            recordPreparedAssignment = () =>
              recordAssignment({
                campaignId: preparedCampaignId,
                variantKey: preparedVariantKey,
              });

            Promise.resolve()
              .then(() => {
                Utils.releaseUnusedScopedTargets(preparedVariant);

                if (
                  cachedTrigger &&
                  cachedTrigger.type &&
                  cachedTrigger.type !== "immediate" &&
                  window.MVTTrigger
                ) {
                  Utils.removeScopedHide();
                  window.MVTTrigger.arm(cachedTrigger, function () {
                    Application.applyVariant(preparedVariant);
                  });
                  return undefined;
                }
                return Application.applyVariant(preparedVariant);
              })
              .catch(() => {});

            setTimeout(revealBody, REVEAL_FAST_MS);

            setTimeout(() => {
              if (recordPreparedAssignment) recordPreparedAssignment();
            }, TARGET_REVEAL_MAX_MS);
          }
        }

        try {
          if (!resolvedChangesBase) {
            throw new Error("MVT Engine: Missing changes API base endpoint.");
          }

          const pendingLinkToken = (typeof window !== "undefined" && window.__MVT_LINK_TOKEN) || "";

          let initPayload = null;

          let serveResolvedNoTest = false;
          if (SERVE_ENABLED && !pendingLinkToken) {
            try {
              const serveUrl = `${resolvedChangesBase}/${projectKey}/serve?url=${encodeURIComponent(
                Utils.normalizeUrlForConfig(currentPageUrl),
              )}&device=${encodeURIComponent(Utils.getDeviceType())}`;
              const serveResponse = await fetch(serveUrl, { method: "GET" });
              if (serveResponse.ok) {
                const servePayload = await serveResponse.json();
                const serveData = (servePayload && servePayload.response) || servePayload || {};
                if (
                  serveData.serveCacheable &&
                  serveData.campaignId &&
                  Array.isArray(serveData.changes) &&
                  serveData.changes.length
                ) {
                  initPayload = {
                    response: {
                      token: null,
                      changes: serveData.changes,
                      campaignId: serveData.campaignId,
                      metrics: serveData.metrics || [],

                      activationTrigger: serveData.activationTrigger || null,
                    },
                  };
                  console.log("MVT Engine: served from cacheable /serve", {
                    campaignId: serveData.campaignId,
                    changesCount: serveData.changes.length,
                  });
                } else if (serveData.serveCacheable && !serveData.campaignId) {
                  serveResolvedNoTest = true;
                  console.log("MVT Engine: /serve says no test on this page — revealing");
                }
              }
            } catch (e) {}
          }

          if (serveResolvedNoTest) {
            recordPreparedAssignment = null;
            const AppModule = getApplicationModule();
            if (
              preparedVariant &&
              AppModule &&
              typeof AppModule.cleanupAppliedVariants === "function"
            ) {
              AppModule.cleanupAppliedVariants();
            }
            clearTimeout(hardCapTimer);
            clearTimeout(targetCapTimer);
            reveal();
            return;
          }

          if (!initPayload) {
            const committedExcl = (() => {
              try {
                return Utils.serializeCommittedExclusions
                  ? Utils.serializeCommittedExclusions()
                  : "";
              } catch (e) {
                return "";
              }
            })();
            const pageReferrer = typeof document !== "undefined" ? document.referrer || "" : "";

            const param = (k, v) => (v ? `&${k}=${encodeURIComponent(v)}` : "");
            const initBase =
              `${resolvedChangesBase}/${projectKey}/init` +
              `?group=${encodeURIComponent(assignedGroupParam)}` +
              `&url=${encodeURIComponent(currentPageUrl)}` +
              `&_t=${Date.now()}` +
              param("v", visitorId) +
              param("dt", Utils.getDeviceType()) +
              param("lt", pendingLinkToken) +
              param("xc", committedExcl);

            const INIT_URL_MAX = 1800;
            const refParam = param("ref", pageReferrer);
            const refFitsInUrl = initBase.length + refParam.length <= INIT_URL_MAX;
            const initUrl = refFitsInUrl ? initBase + refParam : initBase;

            console.log("MVT Engine: Init request", {
              url: initUrl,
              visitorId,
              group: assignedGroupParam,
              preflighted: !refFitsInUrl,
            });

            const initResponse = await fetch(initUrl, {
              method: "GET",
              keepalive: true,
              ...(refFitsInUrl ? {} : { headers: { "X-MVT-Referer": pageReferrer } }),
            });

            if (!initResponse.ok) {
              let errorBody = null;
              try {
                errorBody = await initResponse.text();
              } catch (e) {}
              console.error("MVT Engine: Init response error", errorBody);
              throw new Error(`Init HTTP error! status: ${initResponse.status}`);
            }

            initPayload = await initResponse.json();
          }

          const bearerToken = initPayload?.response?.token || null;
          const changes = initPayload?.response?.changes || initPayload?.changes || [];

          const activationTrigger =
            initPayload?.response?.activationTrigger || initPayload?.activationTrigger || null;

          const exclusionGroup =
            initPayload?.response?.exclusionGroup || initPayload?.exclusionGroup || null;

          console.log("MVT Engine: Init response", {
            hasToken: !!bearerToken,
            changesCount: changes.length,
          });

          if (window.MVTTrack && window.MVTTrack.warmToken) {
            void window.MVTTrack.warmToken(resolvedPublicApiBase, projectKey);
          }

          const linkedVisitorId = initPayload?.response?.linkedVisitorId;
          if (
            linkedVisitorId &&
            typeof linkedVisitorId === "string" &&
            linkedVisitorId !== visitorId
          ) {
            if (Utils.persistVisitorId) Utils.persistVisitorId(projectKey, linkedVisitorId);
            visitorId = linkedVisitorId;
          }
          try {
            if (typeof window !== "undefined") window.__MVT_LINK_TOKEN = "";
          } catch (e) {}

          const linkerToken = initPayload?.response?.linkerToken || "";
          const allowedOrigins = initPayload?.response?.allowedOrigins || [];
          const linkSameHost = initPayload?.response?.linkSameHost === true;
          const hasSiblings = Array.isArray(allowedOrigins) && allowedOrigins.length > 0;
          if (linkerToken && (hasSiblings || linkSameHost) && Utils.decorateSiblingLinks) {
            Utils.decorateSiblingLinks(
              linkerToken,
              hasSiblings ? allowedOrigins : [],
              linkSameHost,
            );
          }

          if (linkerToken && linkSameHost && Utils.publishLinkerTokenToUrl) {
            Utils.publishLinkerTokenToUrl(linkerToken);
          }

          const enabledChanges = Array.isArray(changes)
            ? changes.filter((change) => change?.isEnabled !== false)
            : [];

          const selectedVariant = Application.selectVariant(enabledChanges, visitorId);
          const campaignId =
            initPayload?.response?.campaignId ||
            initPayload?.campaignId ||
            selectedVariant?.campaignId;
          const variantKey =
            selectedVariant?.key || initPayload?.response?.variantKey || initPayload?.variantKey;
          const variantId =
            selectedVariant?.id || initPayload?.response?.variantId || initPayload?.variantId;

          const metrics = initPayload?.response?.metrics || [];

          console.log("MVT Engine: Changes response JSON (success)", {
            count: changes.length,
            enabledCount: enabledChanges.length,
            campaignId,
            variantKey,
            variantId,
            metricsCount: metrics.length,
            currentUrl: window.location.href,
            payload: initPayload,
          });

          if (enabledChanges.length === 0 || !campaignId || !variantKey) {
            console.log("MVT Engine: No matching campaign for current URL", {
              currentUrl: window.location.href,
              projectKey: projectKey,
              changesCount: changes.length,
              enabledChangesCount: enabledChanges.length,
              hasCampaignId: !!campaignId,
              hasVariantKey: !!variantKey,
            });

            recordPreparedAssignment = null;

            const AppModule = getApplicationModule();
            if (AppModule && typeof AppModule.cleanupAppliedVariants === "function") {
              AppModule.cleanupAppliedVariants();
            } else {
              console.warn("MVT Engine: Application module not available for cleanup");
            }

            const savedContext = restoreMVTContextFromSession();
            if (savedContext && savedContext.metrics && savedContext.metrics.length > 0) {
              console.log(
                "MVT Engine: Restored context from session for secondary metric tracking",
                {
                  campaignId: savedContext.campaignId,
                  metricsCount: savedContext.metrics.length,
                  currentUrl: window.location.href,
                },
              );

              window.MVTContext = savedContext;

              setupMetricTracking(
                savedContext.metrics,
                savedContext.publicApiBase,
                savedContext.projectId,
                savedContext.campaignId,
                savedContext.visitorId,
              );
            } else {
              window.MVTContext = null;
            }

            if (CACHE_ENABLED) {
              Utils.clearCachedVariant(projectKey, currentPageUrl);
            }

            reveal();
            window._MVT_FETCH_FLOW_RUNNING = false;
            return;
          }

          recordPreparedAssignment = null;

          const buildContext = (resolvedVariantId) => ({
            projectId: projectKey,
            campaignId: campaignId,
            variantKey: variantKey,
            variantId: resolvedVariantId || variantId,
            visitorId: visitorId,
            publicApiBase: resolvedPublicApiBase,
            metrics: metrics,
          });

          if (campaignId && variantKey && window.MVTTrack) {
            recordAssignment({ campaignId: campaignId, variantKey: variantKey })
              .then((result) => {
                console.log("MVT Engine: Visitor tracked", {
                  isNewVisitor: result?.isNewVisitor ?? false,
                  variantId: result?.variantId || variantId,
                });

                window.MVTContext = buildContext(result?.variantId);
                saveMVTContextToSession(window.MVTContext);

                setupMetricTracking(
                  metrics,
                  resolvedPublicApiBase,
                  projectKey,
                  campaignId,
                  visitorId,
                );
              })
              .catch((err) => {
                console.warn("MVT Engine: post-tracking setup failed", err);
                window.MVTContext = buildContext(null);
                saveMVTContextToSession(window.MVTContext);
                if (metrics.length > 0) {
                  setupMetricTracking(
                    metrics,
                    resolvedPublicApiBase,
                    projectKey,
                    campaignId,
                    visitorId,
                  );
                }
              });
          } else {
            window.MVTContext = buildContext(null);
            saveMVTContextToSession(window.MVTContext);

            if (metrics.length > 0) {
              setupMetricTracking(
                metrics,
                resolvedPublicApiBase,
                projectKey,
                campaignId,
                visitorId,
              );
            }
          }

          const preparedId = preparedVariant ? preparedVariant.id || preparedVariant.key : null;
          const freshId = selectedVariant ? selectedVariant.id || selectedVariant.key : null;
          if (preparedVariant && preparedId !== freshId) {
            const AppModule = getApplicationModule();
            if (AppModule && typeof AppModule.cleanupAppliedVariants === "function") {
              AppModule.cleanupAppliedVariants();
            }
          }

          Utils.releaseUnusedScopedTargets(selectedVariant);

          if (exclusionGroup && Utils.isExcluded && Utils.isExcluded(exclusionGroup, campaignId)) {
            Utils.removeScopedHide();
            if (CACHE_ENABLED) {
              Utils.clearCachedVariant(projectKey, currentPageUrl);
            }
          } else {
            if (exclusionGroup && Utils.commitExclusion) {
              Utils.commitExclusion(exclusionGroup, campaignId);
            }

            if (
              activationTrigger &&
              activationTrigger.type &&
              activationTrigger.type !== "immediate" &&
              window.MVTTrigger
            ) {
              Utils.removeScopedHide();
              window.MVTTrigger.arm(activationTrigger, function () {
                Application.applyVariant(selectedVariant);
              });
            } else {
              await Application.applyVariant(selectedVariant);
            }

            if (CACHE_ENABLED) {
              Utils.setCachedVariant(projectKey, currentPageUrl, selectedVariant, {
                campaignId,
                variantKey,
                activationTrigger,
              });
            }
          }

          reveal();

          injectVisitorIdIntoForms(visitorId);
        } catch (error) {
          if (recordPreparedAssignment) recordPreparedAssignment();

          throw error;
        } finally {
          window._MVT_FETCH_FLOW_RUNNING = false;
        }
      };

      function injectVisitorIdIntoForms(visitorId) {
        if (!visitorId) return;

        if (Utils && Utils.consentBlocked && Utils.consentBlocked()) {
          window._MVT_PENDING_FORM_STAMP = function () {
            injectVisitorIdIntoForms(Utils.getOrCreateVisitorId(projectKey));
          };
          return;
        }
        window._MVT_PENDING_FORM_STAMP = null;

        try {
          var injectInto = function (form) {
            if (!form || form.querySelector('input[name="mvt_visitor_id"]')) return;
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "mvt_visitor_id";
            input.value = visitorId;
            form.appendChild(input);

            if (window.MVTClaims && window.MVTClaims.ensureTicket) {
              var ticket = window.MVTClaims.ensureTicket({
                publicApiBase: publicApiBase,
                projectKey: projectKey,
              });
              if (ticket) {
                var tInput = document.createElement("input");
                tInput.type = "hidden";
                tInput.name = "mvt_claim";
                tInput.value = ticket;
                form.appendChild(tInput);
              }
            }
          };

          var setManagedValue = function (el) {
            var t = el.tagName;
            var target =
              t === "INPUT" || t === "TEXTAREA" || t === "SELECT"
                ? el
                : el.querySelector("input, textarea, select");
            if (!target || target.value === visitorId) return;
            try {
              var proto =
                target.tagName === "TEXTAREA"
                  ? window.HTMLTextAreaElement
                  : target.tagName === "SELECT"
                    ? window.HTMLSelectElement
                    : window.HTMLInputElement;
              var desc = Object.getOwnPropertyDescriptor(proto.prototype, "value");
              var last = target.value;
              if (desc && desc.set) desc.set.call(target, visitorId);
              else target.value = visitorId;

              if (target._valueTracker) target._valueTracker.setValue(last);
              target.dispatchEvent(new Event("input", { bubbles: true }));
              target.dispatchEvent(new Event("change", { bubbles: true }));
            } catch (e) {
              try {
                target.value = visitorId;
              } catch (e2) {}
            }
          };
          var populateManaged = function () {
            var nodes = document.querySelectorAll(
              '[data-custom-type="[mvt_visitor_id]"],' +
                '[data-custom-type="mvt_visitor_id"],' +
                'input[name="[mvt_visitor_id]"],' +
                'input[data-q="mvt_visitor_id"]',
            );
            for (var p = 0; p < nodes.length; p++) setManagedValue(nodes[p]);
          };

          var stampCalUrl = function (url) {
            if (!url || url.indexOf("mvt_visitor_id=") !== -1) return url;
            return (
              url +
              (url.indexOf("?") !== -1 ? "&" : "?") +
              "mvt_visitor_id=" +
              encodeURIComponent(visitorId)
            );
          };
          var isCalHost = function (href) {
            try {
              var h = new URL(href, window.location.href).hostname.toLowerCase();
              return (
                h === "cal.com" ||
                h === "www.cal.com" ||
                h === "app.cal.com" ||
                (h.length > 8 && h.slice(-8) === ".cal.com")
              );
            } catch (e) {
              return false;
            }
          };
          var stampCalLinks = function () {
            var anchors = document.querySelectorAll('a[href*="cal.com"]');
            for (var a = 0; a < anchors.length; a++) {
              var href = anchors[a].getAttribute("href");
              if (!isCalHost(href)) continue;
              var stamped = stampCalUrl(href);
              if (stamped !== href) anchors[a].setAttribute("href", stamped);
            }

            var embeds = document.querySelectorAll("[data-cal-link]");
            for (var e = 0; e < embeds.length; e++) {
              var link = embeds[e].getAttribute("data-cal-link");
              var slink = stampCalUrl(link);
              if (slink !== link) embeds[e].setAttribute("data-cal-link", slink);
            }
          };

          var stampCalendlyUrl = function (url) {
            if (!url || url.indexOf("salesforce_uuid=") !== -1) return url;
            return (
              url +
              (url.indexOf("?") !== -1 ? "&" : "?") +
              "salesforce_uuid=" +
              encodeURIComponent(visitorId)
            );
          };
          var isCalendlyHost = function (href) {
            try {
              var h = new URL(href, window.location.href).hostname.toLowerCase();
              return h === "calendly.com" || (h.length > 12 && h.slice(-12) === ".calendly.com");
            } catch (e) {
              return false;
            }
          };
          var stampCalendlyLinks = function () {
            var anchors = document.querySelectorAll('a[href*="calendly.com"]');
            for (var a = 0; a < anchors.length; a++) {
              var href = anchors[a].getAttribute("href");
              if (!isCalendlyHost(href)) continue;
              var stamped = stampCalendlyUrl(href);
              if (stamped !== href) anchors[a].setAttribute("href", stamped);
            }

            var cembeds = document.querySelectorAll('[data-url*="calendly.com"]');
            for (var e2 = 0; e2 < cembeds.length; e2++) {
              var du = cembeds[e2].getAttribute("data-url");
              if (!isCalendlyHost(du)) continue;
              var sdu = stampCalendlyUrl(du);
              if (sdu !== du) cembeds[e2].setAttribute("data-url", sdu);
            }
          };

          var isSamCartHost = function (href) {
            try {
              var h = new URL(href, window.location.href).hostname.toLowerCase();
              return h === "samcart.com" || (h.length > 12 && h.slice(-12) === ".samcart.com");
            } catch (e) {
              return false;
            }
          };
          var stampSamCartLinks = function () {
            var anchors = document.querySelectorAll('a[href*="samcart.com"]');
            if (!anchors.length) return;
            var ticket =
              window.MVTClaims && window.MVTClaims.ensureTicket
                ? window.MVTClaims.ensureTicket({ publicApiBase: publicApiBase, projectKey: projectKey })
                : null;
            for (var a = 0; a < anchors.length; a++) {
              var href = anchors[a].getAttribute("href");
              if (!href || !isSamCartHost(href) || href.indexOf("mvt_visitor_id=") !== -1) continue;
              var stamped =
                href +
                (href.indexOf("?") !== -1 ? "&" : "?") +
                "mvt_visitor_id=" +
                encodeURIComponent(visitorId) +
                (ticket ? "&mvt_claim=" + encodeURIComponent(ticket) : "");
              anchors[a].setAttribute("href", stamped);
            }
          };

          var scan = function () {
            var forms = document.querySelectorAll("form");
            for (var i = 0; i < forms.length; i++) injectInto(forms[i]);
            populateManaged();
            stampCalLinks();
            stampCalendlyLinks();
            stampSamCartLinks();
          };

          scan();

          if (!window._MVT_MANAGED_HOOK_SET) {
            window._MVT_MANAGED_HOOK_SET = true;
            var lastPop = 0;
            var latePopulate = function () {
              var now = +new Date();
              if (now - lastPop < 40) return;
              lastPop = now;
              populateManaged();

              stampCalLinks();
              stampCalendlyLinks();
              stampSamCartLinks();
            };
            document.addEventListener("pointerdown", latePopulate, true);
            document.addEventListener("click", latePopulate, true);
            document.addEventListener("submit", latePopulate, true);
          }

          if (!window.MutationObserver) return;

          if (window._MVT_FORM_OBSERVER_SET) return;
          window._MVT_FORM_OBSERVER_SET = true;
          var scheduled = false;
          var rescan = function () {
            scheduled = false;
            scan();
          };
          var observer = new MutationObserver(function (mutations) {
            if (scheduled) return;
            var relevant = false;
            for (var m = 0; m < mutations.length && !relevant; m++) {
              var nodes = mutations[m].addedNodes;
              for (var n = 0; n < nodes.length; n++) {
                var node = nodes[n];
                if (node.nodeType !== 1) continue;
                if (
                  node.tagName === "FORM" ||
                  node.tagName === "INPUT" ||
                  (node.matches && node.matches('[data-cal-link], a[href*="samcart.com"]')) ||
                  (node.querySelector &&
                    node.querySelector(
                      'form, input, [data-custom-type], [data-cal-link], a[href*="samcart.com"]',
                    ))
                ) {
                  relevant = true;
                  break;
                }
              }
            }
            if (!relevant) return;
            scheduled = true;
            if (window.requestAnimationFrame) window.requestAnimationFrame(rescan);
            else setTimeout(rescan, 16);
          });
          observer.observe(document.body, { childList: true, subtree: true });
          setTimeout(function () {
            try {
              observer.disconnect();
            } catch (e) {}
          }, 10000);
        } catch (e) {
          console.warn("MVT Engine: Failed to inject visitor ID into forms", e);
        }
      }

      function fireMetricConversion(
        metric,
        publicApiBase,
        projectId,
        campaignId,
        visitorId,
        pageUrl,
      ) {
        return fireMetricConversionShared(
          metric,
          publicApiBase,
          projectId,
          campaignId,
          visitorId,
          pageUrl,
        );
      }

      function setupMetricTracking(metrics, publicApiBase, projectId, campaignId, visitorId) {
        if (!metrics || metrics.length === 0) {
          return;
        }

        console.log("MVT Engine: Setting up metric tracking", {
          metricsCount: metrics.length,
          metrics: metrics.map((m) => ({
            id: m.id,
            eventApiName: m.eventApiName,
            type: m.type,
            conditionsCount: m.conditions?.length || 0,
            conditions: m.conditions,
          })),
        });

        const currentUrl = window.location.href;

        resetMetricDedupForNavigation(metrics, currentUrl);

        metrics.forEach((metric) => {
          const shouldTrack = checkMetricConditions(metric.conditions, currentUrl);

          if (!shouldTrack) {
            console.log("MVT Engine: Metric conditions not met", {
              metricId: metric.id,
              eventApiName: metric.eventApiName,
              currentUrl: currentUrl,
              conditions: metric.conditions,
            });
            return;
          }

          console.log("MVT Engine: Metric conditions met, tracking", {
            metricId: metric.id,
            eventApiName: metric.eventApiName,
            type: metric.type,
          });

          const eventApiName = metric.eventApiName?.toLowerCase() || "";

          if (
            eventApiName === "page_view" ||
            eventApiName === "pageview" ||
            eventApiName === "$pageview" ||
            eventApiName === "page_visit"
          ) {
            fireMetricConversion(
              metric,
              publicApiBase,
              projectId,
              campaignId,
              visitorId,
              currentUrl,
            );
          } else if (
            eventApiName === "click" ||
            eventApiName === "$click" ||
            eventApiName === "button_click"
          ) {
            bindFirstEventListener(
              "click",
              metric,
              function () {
                fireMetricConversion(
                  metric,
                  publicApiBase,
                  projectId,
                  campaignId,
                  visitorId,
                  window.location.href,
                );
              },
              false,
            );
          } else if (
            eventApiName === "form_submit" ||
            eventApiName === "$form_submit" ||
            eventApiName === "form_submission" ||
            eventApiName === "submit"
          ) {
            bindFirstEventListener(
              "submit",
              metric,
              function () {
                fireMetricConversion(
                  metric,
                  publicApiBase,
                  projectId,
                  campaignId,
                  visitorId,
                  window.location.href,
                );
              },
              true,
            );
          } else if (window.MVTBehaviorTrack && window.MVTBehaviorTrack.handles(eventApiName)) {
            window.MVTBehaviorTrack.arm(eventApiName, metric, function () {
              fireMetricConversion(
                metric,
                publicApiBase,
                projectId,
                campaignId,
                visitorId,
                window.location.href,
              );
            });
          } else if (
            eventApiName === "purchase" ||
            eventApiName === "$purchase" ||
            eventApiName === "revenue"
          ) {
          } else {
            registerManualMetric(metric, publicApiBase, projectId, campaignId, visitorId);
          }
        });
      }

      function titleMatchesCondition(title, operator, value) {
        if (!value) return false;
        const t = typeof title === "string" ? title : "";
        const v = value;
        switch (operator) {
          case "eq_ci":
            return t.toLowerCase().trim() === v.toLowerCase().trim();
          case "neq_ci":
            return t.toLowerCase().trim() !== v.toLowerCase().trim();
          case "eq_cs":
            return t.trim() === v.trim();
          case "neq_cs":
            return t.trim() !== v.trim();
          case "contains":
            return t.toLowerCase().includes(v.toLowerCase());
          case "not_contains":
            return !t.toLowerCase().includes(v.toLowerCase());
          case "matches_regex_ci":
            try {
              return new RegExp(v, "i").test(t);
            } catch (e) {
              return false;
            }
          case "matches_regex_cs":
            try {
              return new RegExp(v).test(t);
            } catch (e) {
              return false;
            }
          default:
            return false;
        }
      }

      function checkMetricConditions(conditions, currentUrl) {
        return evaluateMetricConditions(conditions, currentUrl, {
          matchesTitle: titleMatchesCondition,
          matchesUrl: urlMatchesCondition,
        });
      }

      function normalizeUrlWithSettings(url, settings) {
        if (!url) return "";
        var normalized = url;

        normalized = normalized.replace(/^https?:\/\//i, "");
        normalized = normalized.replace(/^www\./i, "");

        if (settings && settings.ignoreFragment) {
          normalized = normalized.replace(/#.*$/, "");
        }

        if (!settings || settings.ignoreQueryString !== false) {
          normalized = normalized.replace(/\?.*$/, "");
        }

        if (!settings || settings.caseInsensitive !== false) {
          normalized = normalized.toLowerCase();
        }

        normalized = normalized.replace(/\/(?:index|default)\.(?:html?|php|aspx?)$/i, "/");

        normalized = normalized.replace(/\/+$/, "");
        return normalized;
      }

      function urlMatchesCondition(url, operator, value, settings) {
        if (!url || !value) {
          return false;
        }

        if (operator === "url_matches_pattern") {
          var escaped = value.replace(/[.+?^${}()|[\]\\]/g, "\\$&");
          var wildcarded = escaped.replace(/\*/g, ".*");
          var flags = !settings || settings.caseInsensitive !== false ? "i" : "";
          try {
            var regex = new RegExp("^" + wildcarded + "$", flags);
            var testUrl = url;

            if (!settings || settings.ignoreQueryString !== false) {
              testUrl = testUrl.replace(/\?[^#]*/, "");
            }
            if (settings && settings.ignoreFragment) {
              testUrl = testUrl.replace(/#.*$/, "");
            }
            return regex.test(testUrl);
          } catch (e) {
            return false;
          }
        }

        if (operator === "url_matches_regex") {
          try {
            var flags2 = !settings || settings.caseInsensitive !== false ? "i" : "";
            var regex2 = new RegExp(value, flags2);
            return regex2.test(url);
          } catch (e) {
            console.warn("MVT Engine: Invalid regex in metric condition", value);
            return false;
          }
        }

        var normalizedUrl = normalizeUrlWithSettings(url, settings);
        var normalizedValue = normalizeUrlWithSettings(value, settings);

        var csUrl = normalizeUrlWithSettings(
          url,
          Object.assign({}, settings || {}, { caseInsensitive: false }),
        );
        var csValue = normalizeUrlWithSettings(
          value,
          Object.assign({}, settings || {}, { caseInsensitive: false }),
        );

        switch (operator) {
          case "url_matches":
          case "url":
          case "equals":
          case "eq_ci":
            return normalizedUrl === normalizedValue;
          case "eq_cs":
            return csUrl === csValue;
          case "neq_ci":
            return normalizedUrl !== normalizedValue;
          case "neq_cs":
            return csUrl !== csValue;

          case "url_contains":
          case "contains":
            return normalizedUrl.includes(normalizedValue);
          case "not_contains":
            return !normalizedUrl.includes(normalizedValue);

          case "url_starts_with":
          case "starts_with":
            return normalizedUrl.startsWith(normalizedValue);
          case "url_ends_with":
          case "ends_with":
            return normalizedUrl.endsWith(normalizedValue);

          case "matches_regex":
          case "matches_regex_ci":
          case "matches_regex_cs":
            try {
              var reFlags = operator === "matches_regex_cs" ? "" : "i";
              return new RegExp(value, reFlags).test(url);
            } catch (e) {
              console.warn("MVT Engine: Invalid regex in metric condition", value);
              return false;
            }

          default:
            console.warn(
              "MVT Engine: Unknown metric condition operator, condition ignored",
              operator,
            );
            return false;
        }
      }

      let verifySuccess = false;

      try {
        if (isVerifyMode) {
          verifySuccess = await runVerifyFlow();
        } else {
          await runChangesFlow();
        }
      } catch (error) {
        console.error("MVT Engine: Request flow failed or applied with error.", error);
      } finally {
        clearTimeout(hardCapTimer);
        clearTimeout(targetCapTimer);
        reveal();
      }

      if (isVerifyMode && verifySuccess) {
        try {
          console.log("MVT Engine: Verify mode success; attempting to close tab.");
          setTimeout(function () {
            try {
              window.open("", "_self");
            } catch (e) {}
            try {
              window.close();
            } catch (e) {}
          }, 50);
        } catch (e) {}
      }
    },
  };

  window.MVTFetchModule = FETCH;

  window.MVTCheckMetricConditions = checkMetricConditionsGlobal;

  function titleMatchesConditionGlobal(title, operator, value) {
    if (!value) return false;
    const t = typeof title === "string" ? title : "";
    const v = value;
    switch (operator) {
      case "eq_ci":
        return t.toLowerCase().trim() === v.toLowerCase().trim();
      case "neq_ci":
        return t.toLowerCase().trim() !== v.toLowerCase().trim();
      case "eq_cs":
        return t.trim() === v.trim();
      case "neq_cs":
        return t.trim() !== v.trim();
      case "contains":
        return t.toLowerCase().includes(v.toLowerCase());
      case "not_contains":
        return !t.toLowerCase().includes(v.toLowerCase());
      case "matches_regex_ci":
        try {
          return new RegExp(v, "i").test(t);
        } catch (e) {
          return false;
        }
      case "matches_regex_cs":
        try {
          return new RegExp(v).test(t);
        } catch (e) {
          return false;
        }
      default:
        return false;
    }
  }

  function checkMetricConditionsGlobal(conditions, currentUrl) {
    return evaluateMetricConditions(conditions, currentUrl, {
      matchesTitle: titleMatchesConditionGlobal,
      matchesUrl: urlMatchesConditionGlobal,
    });
  }

  function evaluateMetricConditions(conditions, currentUrl, matchers) {
    if (!conditions || conditions.length === 0) {
      return true;
    }

    const referrerUrl =
      typeof document !== "undefined" && document.referrer ? document.referrer : "";
    const pageTitle = typeof document !== "undefined" && document.title ? document.title : "";

    const includeGroups = {};
    let sawUnsupportedInclude = false;

    for (const condition of conditions) {
      if (!condition) continue;
      const type = condition.conditionType;
      const isExclude = condition.operation === "exclude";

      let matches;
      if (type === "page_title") {
        matches = matchers.matchesTitle(pageTitle, condition.operator, condition.value);
      } else if (type === "page_url" || type === "referrer_url") {
        const urlToCheck = type === "referrer_url" ? referrerUrl : currentUrl;
        matches = matchers.matchesUrl(
          urlToCheck,
          condition.operator,
          condition.value,
          condition.settings,
        );
      } else {
        if (isExclude) {
          continue;
        }
        sawUnsupportedInclude = true;
        console.warn("MVT Engine: Unsupported metric condition type, metric will not fire", {
          conditionType: type,
        });
        continue;
      }

      if (isExclude) {
        if (matches) return false;
        continue;
      }

      const group = includeGroups[type] || (includeGroups[type] = { anyMatched: false });
      if (matches) group.anyMatched = true;
    }

    if (sawUnsupportedInclude) return false;

    for (const type in includeGroups) {
      if (!Object.prototype.hasOwnProperty.call(includeGroups, type)) continue;
      if (!includeGroups[type].anyMatched) return false;
    }

    return true;
  }

  function normalizeUrlWithSettingsGlobal(url, settings) {
    if (!url) return "";
    var normalized = url;
    normalized = normalized.replace(/^https?:\/\//i, "");

    normalized = normalized.replace(/^www\./i, "");
    if (settings && settings.ignoreFragment) {
      normalized = normalized.replace(/#.*$/, "");
    }
    if (!settings || settings.ignoreQueryString !== false) {
      normalized = normalized.replace(/\?.*$/, "");
    }
    if (!settings || settings.caseInsensitive !== false) {
      normalized = normalized.toLowerCase();
    }

    normalized = normalized.replace(/\/(?:index|default)\.(?:html?|php|aspx?)$/i, "/");
    normalized = normalized.replace(/\/+$/, "");
    return normalized;
  }

  function urlMatchesConditionGlobal(url, operator, value, settings) {
    if (!url || !value) {
      return false;
    }

    if (operator === "url_matches_pattern") {
      var escaped = value.replace(/[.+?^${}()|[\]\\]/g, "\\$&");
      var wildcarded = escaped.replace(/\*/g, ".*");
      var flags = !settings || settings.caseInsensitive !== false ? "i" : "";
      try {
        var regex = new RegExp("^" + wildcarded + "$", flags);
        var testUrl = url;
        if (!settings || settings.ignoreQueryString !== false) {
          testUrl = testUrl.replace(/\?[^#]*/, "");
        }
        if (settings && settings.ignoreFragment) {
          testUrl = testUrl.replace(/#.*$/, "");
        }
        return regex.test(testUrl);
      } catch (e) {
        return false;
      }
    }

    if (operator === "url_matches_regex") {
      try {
        var flags2 = !settings || settings.caseInsensitive !== false ? "i" : "";
        var regex2 = new RegExp(value, flags2);
        return regex2.test(url);
      } catch (e) {
        console.warn("MVT Engine: Invalid regex in metric condition", value);
        return false;
      }
    }

    var normalizedUrl = normalizeUrlWithSettingsGlobal(url, settings);
    var normalizedValue = normalizeUrlWithSettingsGlobal(value, settings);

    var csUrl = normalizeUrlWithSettingsGlobal(
      url,
      Object.assign({}, settings || {}, { caseInsensitive: false }),
    );
    var csValue = normalizeUrlWithSettingsGlobal(
      value,
      Object.assign({}, settings || {}, { caseInsensitive: false }),
    );

    switch (operator) {
      case "url_matches":
      case "url":
      case "equals":
      case "eq_ci":
        return normalizedUrl === normalizedValue;
      case "eq_cs":
        return csUrl === csValue;
      case "neq_ci":
        return normalizedUrl !== normalizedValue;
      case "neq_cs":
        return csUrl !== csValue;

      case "url_contains":
      case "contains":
        return normalizedUrl.includes(normalizedValue);
      case "not_contains":
        return !normalizedUrl.includes(normalizedValue);

      case "url_starts_with":
      case "starts_with":
        return normalizedUrl.startsWith(normalizedValue);
      case "url_ends_with":
      case "ends_with":
        return normalizedUrl.endsWith(normalizedValue);

      case "matches_regex":
      case "matches_regex_ci":
      case "matches_regex_cs":
        try {
          var reFlags = operator === "matches_regex_cs" ? "" : "i";
          return new RegExp(value, reFlags).test(url);
        } catch (e) {
          console.warn("MVT Engine: Invalid regex in metric condition", value);
          return false;
        }

      default:
        console.warn("MVT Engine: Unknown metric condition operator, condition ignored", operator);
        return false;
    }
  }

  function recheckMetricsOnNavigation() {
    let context = window.MVTContext;
    if (!context || !context.metrics || context.metrics.length === 0) {
      context = restoreMVTContextFromSession();
    }
    if (!context || !context.metrics || context.metrics.length === 0) {
      console.log("MVT Engine: No metrics context for navigation check");
      return;
    }

    const currentUrl = window.location.href;
    console.log("MVT Engine: Rechecking metrics on navigation", {
      currentUrl: currentUrl,
      metricsCount: context.metrics.length,
    });

    resetMetricDedupForNavigation(context.metrics, currentUrl);

    context.metrics.forEach((metric) => {
      const shouldTrack = checkMetricConditionsGlobal(metric.conditions, currentUrl);

      if (!shouldTrack) {
        console.log("MVT Engine: Metric conditions not met on navigation", {
          metricId: metric.id,
          eventApiName: metric.eventApiName,
          currentUrl: currentUrl,
        });
        return;
      }

      console.log("MVT Engine: Metric conditions met on navigation, tracking", {
        metricId: metric.id,
        eventApiName: metric.eventApiName,
        type: metric.type,
      });

      const eventApiName = metric.eventApiName?.toLowerCase() || "";

      if (
        eventApiName === "page_view" ||
        eventApiName === "pageview" ||
        eventApiName === "$pageview" ||
        eventApiName === "page_visit"
      ) {
        fireMetricConversionShared(
          metric,
          context.publicApiBase,
          context.projectId,
          context.campaignId,
          context.visitorId,
          currentUrl,
        );
      } else if (
        eventApiName === "click" ||
        eventApiName === "$click" ||
        eventApiName === "button_click"
      ) {
        bindFirstEventListener(
          "click",
          metric,
          function () {
            fireMetricConversionShared(
              metric,
              context.publicApiBase,
              context.projectId,
              context.campaignId,
              context.visitorId,
              window.location.href,
            );
          },
          false,
        );
      } else if (
        eventApiName === "form_submit" ||
        eventApiName === "$form_submit" ||
        eventApiName === "form_submission" ||
        eventApiName === "submit"
      ) {
        bindFirstEventListener(
          "submit",
          metric,
          function () {
            fireMetricConversionShared(
              metric,
              context.publicApiBase,
              context.projectId,
              context.campaignId,
              context.visitorId,
              window.location.href,
            );
          },
          true,
        );
      } else if (window.MVTBehaviorTrack && window.MVTBehaviorTrack.handles(eventApiName)) {
        window.MVTBehaviorTrack.arm(eventApiName, metric, function () {
          fireMetricConversionShared(
            metric,
            context.publicApiBase,
            context.projectId,
            context.campaignId,
            context.visitorId,
            window.location.href,
          );
        });
      } else if (
        eventApiName !== "purchase" &&
        eventApiName !== "$purchase" &&
        eventApiName !== "revenue"
      ) {
        registerManualMetric(
          metric,
          context.publicApiBase,
          context.projectId,
          context.campaignId,
          context.visitorId,
        );
      }
    });
  }

  window.MVTRecheckMetrics = recheckMetricsOnNavigation;
})(window, document);
